import type { JSONContent } from '@tiptap/core'
import { loadDraft } from '@/utils/draftStorage'

/**
 * The consult pad (ADR-026): the block editor NoteDetail shows during a local
 * recording, for injection maps, tables and photos filled in mid-consult. It
 * lives only in this browser's draft storage until the generated note lands
 * and the pad's blocks are appended to it.
 */
export function consultPadKey(noteId: number): string {
  return `consult-pad:${noteId}`
}

/** The pad's blocks that hold something (an empty paragraph does not). */
export function consultPadBlocks(content: JSONContent | null | undefined): JSONContent[] {
  return (content?.content ?? []).filter((n) => n.type !== 'paragraph' || (n.content?.length ?? 0) > 0)
}

/** Whether the clinician put anything on this note's pad. */
export function consultPadHasContent(noteId: number): boolean {
  return consultPadBlocks(loadDraft<{ content: JSONContent }>(consultPadKey(noteId))?.content).length > 0
}
